import { customerSegmentsSlice } from "./customerSegmentsSlice";
import * as actions from "./customerSegmentsActions";
import * as selectors from "./customerSegmentsSelectors";

export { actions };
export { selectors };
export default customerSegmentsSlice.reducer;
